import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '../layouts/MainLayout.vue'
// import Dashboard from '../views/Dashboard.vue'
import Login from "../views/Login.vue"
import store from '../store'
const routes = [
  {
    path: '/home',
    component: MainLayout,
    children: [
      {
        path:'/inicio',
        name: 'inicio',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/inicio.vue')
        }
      },
      {
        path:'//dashboardFac',
        name: 'dashboard',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/Dashboard.vue')
        }
      },
      {
        path:'/dashboard',
        name: 'Dashboard',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/Dashboard2.vue')
        }
      },
      {
        path: '/about',
        name: 'about',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/AboutView.vue')
        }
      },
      {
        path: '/docentes',
        name: 'docentes',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/docentes.vue')
        }
      },
      {
        path: '/certificados',
        name: 'certificados',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/certificados.vue')
        }
      },

      {
        path: '/estudiantes',
        name: 'estudiantes',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/estudiantes.vue')
        }
      },

      {
        path: '/voluntariado',
        name: 'voluntariado',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/voluntariado.vue')
        }
      },


      {
        path: '/sanciones',
        name: 'sancioness',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/sanciones.vue')
        }
      },
      {
        path: '/editar/:id',
        name: 'editars',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/editar.vue')
        }
      },

      {
        path: '/upload/:id',
        name: 'uploads',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/upload.vue')
        }
      },
      {
        path: '/seguimientoGrupo/:id',
        name: 'seguimientoGrupo',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/seguimientoGrupo.vue')
        }
      },

      {
        path: '/crear',
        name: 'crear',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/crear.vue')
        }
      },

      {
        path: '/documentos',
        name: 'documentos',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/documentos.vue')
        }
      },
      {
        path: '/grupos',
        name: 'grupos',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/grupos.vue')
        }
      },
      {
        path: '/busqueda',
        name: 'busqueda',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/busqueda.vue')
        }
      },

      {
        path: '/revision',
        name: 'revision',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/revision.vue')
        }
      },
      
      {
        path: '/formulario',
        name: 'formulario',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/formulario.vue')
        }
      },
      {
        path: '/relacionsancionados',
        name: 'relacionsancionados',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/relacionsancionados.vue')
        }
      },
      {
        path: '/alerta',
        name: 'alerta',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/alerta.vue')
        }
      },
      {
        path: '/particles',
        name: 'particles',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/particles.vue')
        }
      },
      {
        path: '/autoridades',
        name: 'autoridades',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/autoridades.vue')
        }
      },
      {
        path: '/gruposps',
        name: 'gruposps',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/gruposps.vue')
        }
      },
      {
        path: '/visualizar/:id',
        name: 'visualizar',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/visualizar.vue')
        }
      },
      {
        path: '/reportes',
        name: 'reportes',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/reportes.vue')
        }
      },
      {
        path: '/reportesDocentes',
        name: 'reportesDocentes',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/reportesDocentes.vue')
        }
      },
      {
        path: '/resolucion/:id',
        name: 'resolucion',
        meta:{
          requiresAuth: true
        },
        component: function () {
          return import('../views/resolucion.vue')
        }
      },
      {
        path: '/lockscreen',
        name: 'lockscreen',
        
        component: function () {
          return import('../views/lockscreen.vue')
        }
      },

    ]
  },
  {
    path: '/',
    name: 'session',
    component: Login,
  },

  {
    path: '/seguimiento',
    name: 'seguimientoGruposProyeccion',
    meta:{
      requiresAuth: false
    },
    component: function () {
      return import('../views/seguimientoGruposProyeccion.vue')
    }
  },
  {
    path: '/seguimientoGrupos/:id',
    name: 'seguimientoGrupos',
    meta:{
      requiresAuth: false
    },
    component: function () {
      return import('../views/seguimientoGrupos.vue')
    }
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) =>{

  
  const rutaIsProtected  = to.matched.some(record => record.meta.requiresAuth)
  if(rutaIsProtected && sessionStorage.token == null){
    next('/')
  }else if(!rutaIsProtected && !!sessionStorage.token ){
    next('/inicio') //o cualquier ruta donde quieras que vuelva
  }else{
    next()
  }


})


export default router


// export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_API;

